import { createApp } from 'vue'
import { createPinia, getActivePinia } from 'pinia' // Importa Pinia e getActivePinia
import App from './App.vue'
import router from './router' // 1. Importa o nosso novo ficheiro de rotas
import axios from 'axios'
import { useAuthStore } from './stores/auth' // Importar store para interceptor e init

// IMPORTAÇÕES DE ESTILO
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/main.css' // GUARDIÃO: Importação do CSS Global (Ghost Badges e Ícones)
import './assets/relatorioPaged.css' // CSS Paged Media para preview de relatórios com Paged.js

// IMPORTAÇÃO DO JAVASCRIPT DO BOOTSTRAP
import 'bootstrap/dist/js/bootstrap.bundle.min.js'

// --- Configuração do Axios Interceptor ---
axios.interceptors.response.use(
  response => response, // Passa respostas de sucesso direto
  error => {
    // Verifica se é erro 401
    if (error.response && error.response.status === 401) {
      console.warn('Axios Interceptor: Recebido 401. A deslogar...')
      const activePinia = getActivePinia()
      if (activePinia) {
        const authStoreInterceptor = useAuthStore(activePinia)
        // Evita loop infinito e garante que não estamos já no Login
        if (router.currentRoute.value.name !== 'Login') {
          console.log('[Axios Interceptor] Chamando authStore.logout() e redirecionando para Login...')
          authStoreInterceptor.logout() // 1. Chama a ação da store para limpar o estado
          router.push('/') // 2. O INTERCEPTOR faz o redirecionamento
        }
      } else {
        // ... (código de fallback, idealmente também deveria redirecionar) ...
        console.error('[Axios Interceptor] Instância Pinia não encontrada. Logout manual e redirect forçado.')
        localStorage.removeItem('authToken')
        if (window.location.pathname !== '/') {
          window.location.href = '/' // Força redirect
        }
      }
    }
    // Rejeita a promise para que outros .catch() possam lidar com o erro
    return Promise.reject(error)
  }
)
// --- Fim do Interceptor ---

const app = createApp(App)

const pinia = createPinia() // 2. Crie a instância do Pinia

app.use(pinia) // 3. Diga à sua aplicação para usar o Pinia

// Inicializa a authStore - Isso executa descodificarToken() ANTES da guarda de navegação
useAuthStore()
// --- Fim da Inicialização Antecipada ---

app.use(router) // 2. Diga à sua aplicação para usar o router
app.mount('#app') // 4. Monte a aplicação no final
